import { gql } from 'graphql-request'

export const QueryBlockFeatureContact = gql`
  fragment FragmentBlockFeatureContact on BlockFeatureContactModelRecord {
          __typename
          id
          title
          preface
          anchor
          simpleContentBlocks {
            ...FragmentSimpleBlock
          }
          featureCards {
            ...FragmentFeatureCardBlock
          }
        }
`

export const BlockFeatureContact = {
  __typename: 'BlockFeatureContact',
  fragmentName: 'FragmentBlockFeatureContact',
  fragmentQuery: QueryBlockFeatureContact,
  fragments: [
    'FragmentNavigationItem',
    'FragmentFeatureCardBlock',
    'FragmentSimpleBlock',
    'FragmentFormattedTextBlock'
  ]
}
